import React from "react";
import {
  Box,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Select,
  FormErrorMessage,
  Text,
  InputGroup,
  InputLeftElement,
  InputRightElement,
} from "@chakra-ui/react";

const CustomInput = ({
  // First field props
  label1,
  subLabel1,
  value1,
  onChange1,
  onBlur1,
  placeholder1,
  error1,
  required1 = false,
  disabled1 = false,
  type1 = "text",
  area1 = false,
  select1 = false,
  options1 = [],
  leftElement1,
  rightElement1,

  // Second field props
  label2,
  subLabel2,
  value2,
  onChange2,
  onBlur2,
  placeholder2,
  error2,
  required2 = false,
  disabled2 = false,
  type2 = "text",
  area2 = false,
  select2 = false,
  options2 = [],
  leftElement2,
  rightElement2,

  // Common props
  mb = 4,
  ...props
}) => {
  // Common field styles
  const fieldStyles = {
    bg: "white",
    borderColor: "gray.300",
    _hover: {
      borderColor: "gray.400",
    },
    _focus: {
      borderColor: "blue.500",
      boxShadow: "0 0 0 1px #3182ce",
    },
    _invalid: {
      borderColor: "red.500",
      boxShadow: "0 0 0 1px #e53e3e",
    },
    size: "md",
  };

  const renderField = (
    label,
    subLabel,
    value,
    onChange,
    onBlur,
    placeholder,
    error,
    required,
    disabled,
    type,
    isArea,
    isSelect,
    options,
    leftElement,
    rightElement
  ) => (
    <FormControl isInvalid={!!error} isRequired={required}>
      <FormLabel fontSize="sm" fontWeight="medium" color="gray.700">
        {label}
        {subLabel && (
          <label
            style={{
              marginLeft: "0.3rem",
              color: "gray.500",
              fontWeight: "normal",
              fontSize: "0.875rem",
            }}
          >
            ( {subLabel})
          </label>
        )}
      </FormLabel>

      {isSelect ? (
        // Select dropdown (no left/right elements support)
        <Select
          value={value || ""}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder || `Select ${label}`}
          disabled={disabled}
          {...fieldStyles}
        >
          {options.map((option, index) => (
            <option
              key={typeof option === "object" ? option.value : option}
              value={typeof option === "object" ? option.value : option}
            >
              {typeof option === "object" ? option.label : option}
            </option>
          ))}
        </Select>
      ) : isArea ? (
        // Textarea (no left/right elements support)
        <Textarea
          value={value || ""}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          rows={4}
          resize="vertical"
          {...fieldStyles}
        />
      ) : leftElement || rightElement ? (
        // Input with left/right elements
        <InputGroup>
          {leftElement && (
            <InputLeftElement
              pointerEvents={
                typeof leftElement === "function" ? "auto" : "none"
              }
              children={leftElement}
            />
          )}
          <Input
            type={type}
            value={value || ""}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
            disabled={disabled}
            pl={leftElement ? 10 : undefined}
            pr={rightElement ? 10 : undefined}
            {...fieldStyles}
          />
          {rightElement && (
            <InputRightElement pointerEvents="auto" children={rightElement} />
          )}
        </InputGroup>
      ) : (
        // Regular input without elements
        <Input
          type={type}
          value={value || ""}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          {...fieldStyles}
        />
      )}

      {error && (
        <FormErrorMessage fontSize="sm" mt={1}>
          {error}
        </FormErrorMessage>
      )}
    </FormControl>
  );

  // If only first field is provided, render single field
  if (!label2) {
    return (
      <Box mb={mb} {...props}>
        {renderField(
          label1,

          subLabel1,
          value1,
          onChange1,
          onBlur1,
          placeholder1,
          error1,
          required1,
          disabled1,
          type1,
          area1,
          select1,
          options1,
          leftElement1,
          rightElement1
        )}
      </Box>
    );
  }

return (
  <Box mb={mb} {...props}>
    <Flex gap={4} direction={["column", "column", "row"]} flexWrap="wrap">
      <Box flex={1} minW={["100%", "100%", "0"]}>
        {renderField(
          label1,
          subLabel1,
          value1,
          onChange1,
          onBlur1,
          placeholder1,
          error1,
          required1,
          disabled1,
          type1,
          area1,
          select1,
          options1,
          leftElement1,
          rightElement1
        )}
      </Box>
      <Box flex={1} minW={["100%", "100%", "0"]}>
        {renderField(
          label2,
          subLabel2,
          value2,
          onChange2,
          onBlur2,
          placeholder2,
          error2,
          required2,
          disabled2,
          type2,
          area2,
          select2,
          options2,
          leftElement2,
          rightElement2
        )}
      </Box>
      {props.label3 && (
        <Box flex={1} minW={["100%", "100%", "0"]}>
          {renderField(
            props.label3,
            props.subLabel3,
            props.value3,
            props.onChange3,
            props.onBlur3,
            props.placeholder3,
            props.error3,
            props.required3,
            props.disabled3,
            props.type3,
            props.area3,
            props.select3,
            props.options3,
            props.leftElement3,
            props.rightElement3
          )}
        </Box>
      )}
    </Flex>
  </Box>
);

};

export default CustomInput;
